import React from 'react'

import AppBar from './components/AppBar'
import BreadcrumbBar from './components/BreadcrumbBar'

/** @type {import('./types').default} */
const Header = ({ breadcrumbs = [], user }) => {
  return (
    <>
      <AppBar user={user} />
      {!!breadcrumbs.length && <BreadcrumbBar breadcrumbs={breadcrumbs} />}
    </>
  )
}

export default Header
